import React from "react";
import Gravatar from "react-gravatar";
import styles from "./style.module.scss";

const Avatar = ({ email, radius }) => {
  return (
    <div className={styles.avatar}>
      <Gravatar email={email} className={radius && styles.avatar__radius} />
    </div>
  );
};

export default Avatar;
